import { jsxs as Q, jsx as B } from "react/jsx-runtime";
import b from "./styles.module.less.js";
import { forwardRef as U, useMemo as v, useState as S, useRef as k, useCallback as p, useEffect as x, useImperativeHandle as X } from "react";
import { ProgressBarComponent as Z } from "./progress-bar.js";
import { isTouchDevice as N } from "../../../utils/is-touch-device.js";
const tt = 30, et = U((E, F) => {
  const {
    showProgressBar: z,
    items: e,
    offsetWidth: D,
    onInit: C,
    classNames: h,
    debug: o,
    cardWidth: f,
    columnCount: W,
    minColumnWidth: L,
    maxColumnWidth: P
  } = E, O = v(() => E.showArrows != null ? E.showArrows : !N(), [E.showArrows]), r = v(() => D ?? 20, [D]), [d, $] = S(0), [s, H] = S(
    f ?? 0
  ), [n, R] = S(W ?? 0), c = k(null), a = k(null), g = k(null), M = v(
    () => e != null && e.length && n ? 1 / (e.length + 1 - n) : 0,
    [n, e == null ? void 0 : e.length]
  ), V = v(() => n && d != null && e.length != null && M != null && e.length + 1 - n > 0 ? d * M * 100 : 0, [d, n, e.length, M]), y = p(
    (t) => {
      g.current && (clearTimeout(g.current), g.current = null), c.current && (o && (console.log("new Index ", t), console.log(
        "scrolling to ",
        t * s + r * t
      )), c.current.scrollTo({
        left: t * s + r * t,
        behavior: "smooth"
      }), $(t));
    },
    [o, r, s]
  ), _ = p(() => {
    d > 0 && y(d - 1);
  }, [d, y]), q = p(() => {
    d < e.length && y(d + 1);
  }, [d, e == null ? void 0 : e.length, y]), I = p(() => {
    g.current && (clearTimeout(g.current), g.current = null), g.current = setTimeout(() => {
      var t, l, i;
      if (a.current && ((t = c.current) == null ? void 0 : t.scrollLeft) != null) {
        o && console.log(
          "on scroll handling set active",
          ((l = c.current) == null ? void 0 : l.scrollLeft) / (s + r)
        );
        const u = ((i = c.current) == null ? void 0 : i.scrollLeft) / (s + r);
        e.length - n === Math.ceil(u) ? (o && console.log(
          "setting active index to ",
          e.length - n
        ), $(e.length - n)) : (o && console.log(
          "round setting active index to ",
          Math.round(u)
        ), $(Math.round(u)));
      }
      g.current = null;
    }, tt);
  }, [o, s, r, e.length, n]), A = p(
    (t) => {
      var l, i;
      if ((l = a == null ? void 0 : a.current) != null && l.clientWidth)
        return Math.floor(
          (((i = a == null ? void 0 : a.current) == null ? void 0 : i.clientWidth) + r) / (t + r)
        );
    },
    [r]
  ), j = p(
    (t) => {
      var l, i;
      if ((l = c == null ? void 0 : c.current) != null && l.clientWidth) {
        const u = window.getComputedStyle(c.current), T = u.getPropertyValue("padding-left"), m = u.getPropertyValue("padding-right"), J = T ? parseInt(T) : 0, K = m ? parseInt(m) : 0;
        return Math.round(
          (((i = c == null ? void 0 : c.current) == null ? void 0 : i.clientWidth) - J - K - r * (t - 1)) / t
        );
      }
    },
    [r]
  ), w = p(() => {
    var t;
    if (f) {
      const l = A(f);
      l && (R(l), C == null || C(l)), f !== s && H(f);
    } else if (W) {
      const l = j(W);
      let i = W;
      if (l) {
        let u = l;
        if (L && (u = Math.max(u, L)), P && (u = Math.min(u, P)), (t = a == null ? void 0 : a.current) != null && t.clientWidth) {
          const T = a.current.clientWidth;
          if (L) {
            const m = Math.floor(
              (T + r) / (L + r)
            );
            m < W && (i = m);
          }
          if (P) {
            const m = Math.floor(
              (T + r) / (P + r)
            );
            m > i && (i = m);
          }
        }
        H(u);
      }
      i !== n && (R(i), C == null || C(i));
    }
  }, [
    f,
    W,
    A,
    s,
    C,
    j,
    n,
    L,
    P
  ]);
  x(() => {
    w();
  }, [w]), x(() => (w(), window.addEventListener("resize", w), () => window.removeEventListener("resize", w)), [w]), X(F, () => ({
    cardsScrollRef: c,
    getExpectedCards: A
  })), x(() => {
    o && console.log("expectedCards", n);
  }, [o, n]), x(() => {
    o && console.log("cardWidth", f);
  }, [o, f]), x(() => {
    o && console.log("expectedCardWidth", s);
  }, [o, s]), x(() => {
    o && console.log("offsetWidth", r);
  }, [o, r]), x(() => {
    o && console.log("activeIndex", d);
  }, [o, d]);
  const Y = v(() => {
    let t = {
      gap: `0 ${r}px`
    };
    return s && (t = {
      ...t,
      gridAutoColumns: `minmax(${s}px, 1fr)`,
      gridTemplateColumns: `repeat(auto-fill, minmax(${s}px, 1fr))`
    }), t;
  }, [s, r]), G = v(() => z ? e.length > n : !1, [z, e.length, n]);
  return /* @__PURE__ */ Q(
    "div",
    {
      className: `${b.container} ${(h == null ? void 0 : h.container) ?? ""}`,
      ref: a,
      children: [
        /* @__PURE__ */ B(
          "div",
          {
            className: `${b.cardsContainer} ${(h == null ? void 0 : h.cardsPosition) ?? ""}`,
            children: /* @__PURE__ */ B(
              "div",
              {
                ref: c,
                className: `${b.cards} ${(h == null ? void 0 : h.cardsContainer) ?? ""}`,
                onScroll: I,
                style: Y,
                children: e.map((t) => t)
              }
            )
          }
        ),
        G ? /* @__PURE__ */ B(
          Z,
          {
            classNames: h,
            disabledLeftButton: d <= 0,
            disabledRightButton: d >= e.length - n,
            onLeftButtonClick: _,
            onRightButtonClick: q,
            scrollWidth: M,
            leftPosition: V,
            showArrows: O
          }
        ) : null
      ]
    }
  );
});
et.displayName = "Carousel";
export {
  et as Carousel
};
